import { cekSidak } from "./function";

const initialState = {
  listSidak: [],
  listIssue: [],
  kpi1: null,
  kpi2: null,
  calendar: [],
  cekSidak: [],
};

const sidakReducer = (state = initialState, action) => {
  let { type, data } = action;

  switch (type) {
    case "SET_LISTSIDAK":
      return {
        ...state,
        listSidak: data,
      };
    case "SET_LISTISSUE":
      return {
        ...state,
        listIssue: data,
      };
    case "SET_KPI1SIDAK":
      return {
        ...state,
        kpi1: data,
      };
    case "SET_KPI2RESPONISSUE":
      return {
        ...state,
        kpi2: data,
      };
    case "SET_CALENDAR":
      return {
        ...state,
        calendar: data,
      };
    case "SET_CEKSIDAK":
      return {
        ...state,
        cekSidak: data,
      };

    default:
      return state;
  }
};

export default sidakReducer;
